export function heroSlider() {
    $(window).on('load', function () {
        const slider = $(".hero-slider");
        const progressWrap = $('.hero-slider-progress');
        const progress = progressWrap.find('.active');
        let isAutoplay = false;
        let speed = parseInt(slider.data('speed'));

        if (speed) {
            isAutoplay = true;
        }

        let interval;
        let percentWidth = 0;

        function startProgressbar() {
            resetProgressbar();
            interval = setInterval(function () {
                ++percentWidth;
                progress.css('width', percentWidth + '%');
                if (percentWidth >= 100) {
                    clearInterval(interval);
                }
            }, speed / 100);
        }

        function resetProgressbar() {
            percentWidth = 0;
            progress.css('width', 0);
            clearInterval(interval);
        }


        slider.on('init', function () {
            // startProgressbar();
        });


        slider.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            // autoplay: isAutoplay,
            // autoplaySpeed: speed,
            fade: true,
            dots:true,
            // pauseOnFocus: false,
            // pauseOnHover: false,
        }).on("beforeChange", function () {
            // resetProgressbar();
            // setTimeout(startProgressbar, 300);
        });
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroSlider.js